import React from "react";
import Chart from 'react-apexcharts';
// import LodingSkeleton from "../LoadingSkeletons/LoadingSkeletons";

const ApexChart = ({
    name,
    type,
    series = [],
    categories = [],
    height = '350',
    width = '100%',
    colors,
    axisConfig = { show: true, axisType: 'category', showGrid: true },
    strokeConfig = { curve: 'smooth', width: 2 },
    legendConfig,
    axisValues,
    isLoading
}) => {
    const isPieOrDonut = type === 'pie' || type === 'donut';
    const formattedSeries = isPieOrDonut ? series.flat() : series;

    const commonOptions = {
        chart: {
            zoom: { enabled: false },
            toolbar: { show: false },
            background: "transparent",
            type: type
        },
        title: {
            text: name,
            align: 'left',
            margin: 20,
            offsetY: 10,
            style: {
                fontSize: '1.7rem',
                fontWeight: 'bold',
                color: '#263238'
            }
        },
        dataLabels: { enabled: false },
        colors: colors || [],
        tooltip: {
            y: {
                formatter: (val) => val ? `${val} units` : "No data"
            }
        },
        xaxis: !isPieOrDonut ? {
            type: axisConfig.axisType,
            categories: categories,
            labels: { show: axisConfig.showXaxis },
            axisBorder: { show: axisConfig.show !== false },
            axisTicks: { show: axisConfig.show },
        } : undefined,
        yaxis: !isPieOrDonut ? {
            labels: { show: axisConfig.showYaxis },
            axisBorder: { show: axisConfig.show },
            axisTicks: { show: axisConfig.show }
        } : undefined,
        grid: { show: axisConfig.showGrid },
        stroke: {
            curve: strokeConfig.curve,
            width: strokeConfig.width
        },
    };
    const pieOptions = {
        labels: categories,
        colors: colors,
        title: {
            text: name,
            align: 'left',
            margin: 20,
            offsetY: 10,
            style: {
                fontSize: '1.7rem',
                fontWeight: 'bold',
                color: '#263238'
            }
        },
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
        },
    };
    
    const barOptions = {
        ...commonOptions,
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded',
                distributed: series.length > 1 ? false : true,
            },
        },
        dataLabels: { enabled: false },
        legend: {
            show: legendConfig.show,
            position: 'bottom',
            horizontalAlign: 'center',
        },
    };

    const lineOptions = {
        ...commonOptions,
        dataLabels: { enabled: false },
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
        },
    };

    const donutOptions = {
        labels: categories,
        colors: colors,
        chart: { type: 'donut' },
        title: {
            text: name,
            align: 'left',
            margin: 20,
            offsetY: 10,
            style: {
                fontSize: '1.7rem',
                fontWeight: 'bold',
                color: '#263238'
            }
        },
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
        },
    };

    const singleBaroptions = {
        chart: {
          type: type,
          background: "transparent",
          zoom: { enabled: false },
          toolbar: { show: false },
        },
        // title: {
        //     text: name,
        //     align: 'left',
        //     margin: 20,
        //     offsetY: 10,
        //     style: {
        //         fontSize: '1.7rem',
        //         fontWeight: 'bold',
        //         color: '#263238'
        //     }
        // },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '30%', 
            endingShape: 'flat',
          },
        },
        xaxis: {
          categories: axisValues?.hours || [], 
          position: 'bottom',
          title: {
            text: "Hours", 
            style: {
              fontSize: "12px",
              color: "#333",
            },
            offsetY: -20, 
          },
          labels: {
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
            },
          },
        },
        yaxis: {
          categories: axisValues?.hourQty,
          title: {
            text: "Quantity",
            style: {
              fontSize: "12px",
              color: "#333",
            },
          },
          labels: {
            formatter: (value) => value.toFixed(1), // Format to 1 decimal place
            style: {
              fontSize: '12px',
            },
          },
        },
        grid: {
          show: true,
          borderColor: '#e0e0e0',
        },
        tooltip: {
          y: {
            formatter: (value) => `${value} units`,
          },
        },
        dataLabels: {
          enabled: false, // Disable data labels
        },
        colors: ['#2196F3'], // Bar color
      };


    let options;
    switch (type) {
        case 'pie':
            options = pieOptions;
            break;
        case 'donut':
            options = donutOptions;
            break;
        case 'bar':
            options = axisValues ?
            //  barOptions
            singleBaroptions
             : barOptions;
            break;
        case 'line':
            options = lineOptions;
            break;
        default:
            options = commonOptions;
            break;
    }

    // if (isLoading) {
    //     return <LodingSkeleton type={type} width={width} height={height}/>;
    //   }

    return (
        <Chart
            options={options}
            series={formattedSeries}
            height={height}
            width={width}
            type={type}
        />
    );
};

export default ApexChart;
